import React, { useState } from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Popover, {
    positions,
    PopoverTrigger,
    PopoverLayover,
} from '@tamagoshi/core/Popover';
import { Outline as InfoOutlineIcon } from '@tamagoshi/icons/Info';
import './VATTooltip.scss';

const urls = {
    FR:
        'https://faq.manomano.com/hc/fr/articles/360049192594-TVA-d%C3%A9ductible-ou-non-d%C3%A9ductible-pour-les-professionnels',
};
export default function VATTootip({ className, locale }) {
    const rootClassnames = classnames(className);

    const [popOverVisbility, setPopOverVisibility] = useState(false);
    const onClose = event => {
        event.preventDefault();
        setPopOverVisibility(false);
    };
    const onClick = event => {
        event.preventDefault();
        setPopOverVisibility(!popOverVisbility);
    };
    const onEnter = event => {
        if (event.key === 'Enter') {
            setPopOverVisibility(!popOverVisbility);
        }
    };

    return (
        <div className={rootClassnames}>
            <Popover
                position={positions.BOTTOM}
                fallbackPositions={positions.RIGHT}
                isVisible={popOverVisbility}
                onClose={onClose}
            >
                <PopoverTrigger>
                    {({ ref }) => {
                        return (
                            <span
                                role="button"
                                tabIndex={0}
                                ref={ref}
                                className="product-card-merchandizing--info"
                                onClick={onClick}
                                onKeyPress={onEnter}
                            >
                                <InfoOutlineIcon className="product-card--info-icon vattooltip" />
                            </span>
                        );
                    }}
                </PopoverTrigger>
                <PopoverLayover>
                    <div className="product-card-merchandizing-tooltip--content">
                        <FormattedMessage
                            id="listing.price.VATTtooltip"
                            defaultMessage="VAT not deductible on this product"
                            description="VAT Tooltip label of product card's VAT price"
                        />
                        <br />
                        <a
                            className="vattooltip-link"
                            target="blank"
                            href={urls[locale.toUpperCase()]}
                        >
                            <FormattedMessage
                                id="listing.price.VATTtooltip.link"
                                defaultMessage="More information"
                                description="Link in the VAT Tooltip"
                            />
                        </a>
                    </div>
                </PopoverLayover>
            </Popover>
        </div>
    );
}

VATTootip.propTypes = {
    className: string,
    locale: string.isRequired,
};
VATTootip.defaultProps = {
    className: null,
};
